"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5113],{

/***/ 36013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ AuthDecorator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41248);
/* harmony import */ var _lib_beacon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91435);
/* harmony import */ var _state_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30541);
/* harmony import */ var _utils_node__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49503);



/* eslint-disable no-console */ 




var AuthDecorator = function(param) {
    var children = param.children, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {
        return null;
    } : _onClick;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var handleClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var account, response;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_utils_node__WEBPACK_IMPORTED_MODULE_6__/* .testNodeHealth */ .M)();
                    case 2:
                        _ctx.next = 4;
                        return (0,_lib_beacon__WEBPACK_IMPORTED_MODULE_4__/* .getActiveAccount */ .Fk)();
                    case 4:
                        account = _ctx.sent;
                        if (account) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 8;
                        return (0,_lib_beacon__WEBPACK_IMPORTED_MODULE_4__/* .login */ .x4)();
                    case 8:
                        response = _ctx.sent;
                        dispatch({
                            type: _state_auth__WEBPACK_IMPORTED_MODULE_5__/* .actions.AUTH_LOGIN */ .Nw.AUTH_LOGIN,
                            payload: response
                        });
                    case 10:
                        if (onClick) {
                            onClick();
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var childrenWithProps = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
        if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(child)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, {
                onClick: handleClick
            });
        }
        return child;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: childrenWithProps
    });
};


/***/ }),

/***/ 11422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Avatar; },
  "z": function() { return /* binding */ avatar_Verified; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-avatar/dist/index.module.js
var index_module = __webpack_require__(16235);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/avatar/styles.ts


var Container = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    display: "flex"
});
var StyledRoot = (0,stitches/* styled */.zo)(index_module/* Root */.fC, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    overflow: "hidden",
    userSelect: "none",
    width: 128,
    height: 128,
    backgroundColor: "$secondaryBackground",
    variants: {
        round: {
            true: {
                borderRadius: 9999
            }
        }
    }
});
var StyledImage = (0,stitches/* styled */.zo)(index_module/* Image */.Ee, {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit"
});
var StyledFallback = (0,stitches/* styled */.zo)(index_module/* Fallback */.NY, {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var Verified = (0,stitches/* styled */.zo)("div", {
    margin: "0 $space$5",
    fontSize: 14
});
var Path = (0,stitches/* styled */.zo)("path", {});

;// CONCATENATED MODULE: ./src/components/avatar/index.tsx



var Avatar = function(param) {
    var username = param.username, path = param.path, _round = param.round, round = _round === void 0 ? true : _round, size = param.size;
    if (size) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
                round: round,
                css: {
                    width: size,
                    height: size
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: path,
                        alt: "".concat(username, " profile")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                        delayMs: path ? 600 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                            hash: username
                        })
                    })
                ]
            })
        });
    }
    // adjusts to 100% parent
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        css: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
            round: round,
            css: {
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                "&:after": {
                    content: "",
                    display: "block",
                    paddingTop: "calc(1 * 100%);"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: path,
                    alt: "".concat(username, " profile"),
                    css: {
                        position: "absolute",
                        width: "100%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                    delayMs: path ? 600 : 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                        hash: username
                    })
                })
            ]
        })
    });
};
var avatar_Verified = function(param) {
    var _size = param.size, size = _size === void 0 ? 14 : _size, _secondary = param.secondary, secondary = _secondary === void 0 ? false : _secondary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    d: "M4.78117 0.743103C5.29164 -0.247701 6.70826 -0.247701 7.21872 0.743103C7.52545 1.33846 8.21742 1.62509 8.8553 1.42099C9.91685 1.08134 10.9186 2.08304 10.5789 3.1446C10.3748 3.78247 10.6614 4.47445 11.2568 4.78117C12.2476 5.29164 12.2476 6.70826 11.2568 7.21872C10.6614 7.52545 10.3748 8.21742 10.5789 8.8553C10.9186 9.91685 9.91685 10.9186 8.8553 10.5789C8.21742 10.3748 7.52545 10.6614 7.21872 11.2568C6.70826 12.2476 5.29164 12.2476 4.78117 11.2568C4.47445 10.6614 3.78247 10.3748 3.1446 10.5789C2.08304 10.9186 1.08134 9.91685 1.42099 8.8553C1.62509 8.21742 1.33846 7.52545 0.743103 7.21872C-0.247701 6.70826 -0.247701 5.29164 0.743103 4.78117C1.33846 4.47445 1.62509 3.78247 1.42099 3.1446C1.08134 2.08304 2.08304 1.08134 3.1446 1.42099C3.78247 1.62509 4.47445 1.33846 4.78117 0.743103Z",
                    css: {
                        fill: secondary ? "$secondaryFill" : "$primaryFill"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.43961 4.23998C8.64623 4.43922 8.65221 4.76823 8.45297 4.97484L5.40604 8.13462L3.54703 6.20676C3.34779 6.00014 3.35377 5.67113 3.56039 5.47189C3.76701 5.27266 4.09602 5.27864 4.29526 5.48525L5.40604 6.63718L7.70475 4.25334C7.90398 4.04672 8.23299 4.04074 8.43961 4.23998Z",
                    css: {
                        fill: "$primaryBackground"
                    }
                })
            ]
        })
    });
// return (
//   <svg width={size} height={size} viewBox="0 0 18 18">
//     <g fill="none" fillRule="evenodd">
//       <path fill="#38D" fillRule="nonzero" d="M9 18A9 9 0 108.999-.001 9 9 0 009 18z" />
//       <path stroke="#FFF" strokeWidth="2" d="M4.13 8.767l3.086 3.087 6.656-6.656" />
//     </g>
//   </svg>
// );
};


/***/ }),

/***/ 51288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ FollowUserButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./src/components/auth-decorator/index.tsx
var auth_decorator = __webpack_require__(36013);
// EXTERNAL MODULE: ./src/lib/versum/index.ts + 11 modules
var versum = __webpack_require__(44980);
// EXTERNAL MODULE: ./src/state/user/index.ts
var user = __webpack_require__(98480);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/follow-user-button/styles.ts



var Container = (0,stitches/* styled */.zo)("div", (0,_define_property/* default */.Z)({}, "& ".concat(index_es/* Button */.zx), {
    display: "flex",
    alignItems: "center",
    padding: 8,
    i: {
        fontSize: 16,
        marginRight: 4
    }
}));

;// CONCATENATED MODULE: ./src/components/follow-user-button/index.tsx



/* eslint-disable react/no-unused-prop-types */ 






var FollowUserButton = function(param) {
    var viewer = param.viewer, userId = param.userId, isFollowing = param.isFollowing;
    var ref = (0,react.useState)(false), following = ref[0], setFollowing = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (isFollowing !== undefined) {
            setFollowing(isFollowing);
        }
    }, [
        isFollowing
    ]);
    var handleClick = function() {
        var update = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (following) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 3;
                            return (0,versum/* FollowUser */.Zz)(userId);
                        case 3:
                            _ctx.next = 7;
                            break;
                        case 5:
                            _ctx.next = 7;
                            return (0,versum/* UnfollowUser */.W5)(userId);
                        case 7:
                            // update count on follow/unfollow
                            dispatch({
                                type: user/* actions.USER_UPDATE_USER */.Nw.USER_UPDATE_USER,
                                payload: viewer
                            });
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function update() {
                return _ref.apply(this, arguments);
            };
        }();
        update();
        setFollowing(!following);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: isFollowing !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
            onClick: handleClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                variant: following ? "secondary" : "primary",
                children: [
                    following ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "done"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "add"
                    }),
                    following ? "Following" : "Follow"
                ]
            })
        })
    });
};


/***/ }),

/***/ 5113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ModalManager": function() { return /* binding */ ModalManager; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/modals/styles.ts
var styles = __webpack_require__(45638);
// EXTERNAL MODULE: ./src/lib/beacon.ts + 211 modules
var beacon = __webpack_require__(91435);
// EXTERNAL MODULE: ./src/utils/node.ts
var node = __webpack_require__(49503);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
;// CONCATENATED MODULE: ./src/components/modals/auction-accept-current/index.tsx







var AuctionAcceptCurrentBid = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, auctionId = param.auctionId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* auctionWithdraw */.t0)(auctionId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Accept Current Bid",
        description: "You are about to accept the current bid, if you confirm the auction will finish ahead of time.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/use-intl.esm3.js + 18 modules
var use_intl_esm3 = __webpack_require__(72439);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
;// CONCATENATED MODULE: ./src/components/modals/auction-bid/index.tsx






/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable no-alert */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-console */ 







var AuctionBid = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, auctionId = param.auctionId, currentBid = param.currentBid, isMinBid = param.isMinBid;
    var t = (0,use_intl_esm3/* default */.Z)("market");
    var ref = (0,react.useState)({
        bid: {
            error: false,
            data: null
        }
    }), values = ref[0], setValues = ref[1];
    var minBidValue = isMinBid ? currentBid : new (bignumber_default())(currentBid).times(1.1).toNumber();
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.bid.data) {
            setError("bid", '"Bid" is missing');
            valid = false;
        }
        if (values.bid.data !== null && currentBid !== undefined && minBidValue !== undefined) {
            if ((0,format/* TezToMut */.gu)(values.bid.data) < minBidValue) {
                setError("bid", 'Min "Bid" value '.concat((0,format/* MutToTez */.QO)(minBidValue), " tez"));
                valid = false;
            }
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        (0,beacon/* auctionBid */.VQ)(auctionId, Number(values.bid.data));
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: t("bid"),
        description: "You're about to bid on this token. Your bid needs to be 10% over the current bid (".concat((0,format/* MutToTez */.QO)(minBidValue), " tez)."),
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                uid: "bid",
                label: "Your Bid",
                tooltip: "Your bid needs to be 10% over the last successful bid.",
                error: values.bid.error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                    type: "number",
                    min: 0,
                    max: 10,
                    placeholder: "e.g.: 3.5",
                    onChange: function(value) {
                        return handleChange("bid", value);
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/auction-cancel/index.tsx







var AuctionCancel = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, auctionId = param.auctionId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* auctionWithdraw */.t0)(auctionId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Auction cancel",
        description: "You are about to cancel this auction.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

;// CONCATENATED MODULE: ./src/components/selector-currency/index.tsx



var SelectorCurrency = function(param) {
    var onChange = param.onChange;
    var currencies = (0,es/* useSelector */.v9)(function(state) {
        return state.global;
    }).currencies;
    var temp = currencies.map(function(currency) {
        return {
            value: currency.symbol,
            label: currency.name
        };
    });
    var list = temp.length > 0 ? temp : [
        {
            value: "XTZ",
            label: "Tezos"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Selector */.Qf, {
        value: list[0].value,
        list: list,
        onChange: onChange
    });
};

;// CONCATENATED MODULE: ./src/components/modals/auction-create/index.tsx






/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-explicit-any */ 






var AuctionCreate = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, tokenKT = param.tokenKT, tokenId = param.tokenId, platformName = param.platformName;
    var ref = (0,react.useState)({
        currency: {
            error: false,
            data: null
        },
        price: {
            error: false,
            data: null
        },
        duration: {
            error: false,
            data: null
        }
    }), values = ref[0], setValues = ref[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.price.data) {
            setError("price", '"Price" is missing');
            valid = false;
        }
        if (!values.duration.data) {
            setError("duration", '"Time" is missing');
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        (0,beacon/* auctionCreate */.jo)((0,format/* TezToMut */.gu)(values.price.data), Number(values.duration.data), tokenKT, tokenId, platformName);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Create Auction",
        description: "You're about to create an auction.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "currency",
                    label: "Currency",
                    error: values.currency.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorCurrency, {
                        onChange: function(value) {
                            return handleChange("currency", value);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "price",
                    label: "Start price",
                    tooltip: "Start price of the auction in XTZ",
                    error: values.price.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        type: "number",
                        min: 0,
                        placeholder: "e.g.: 7",
                        onChange: function(value) {
                            return handleChange("price", value);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "duration",
                    label: "Time (hours)",
                    tooltip: "Duration for the auction in hours.",
                    error: values.duration.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        type: "number",
                        min: 24,
                        placeholder: "e.g.: 24",
                        onChange: function(value) {
                            return handleChange("duration", value);
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/auction-finalize/index.tsx







var AuctionFinalize = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, auctionId = param.auctionId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* auctionWithdraw */.t0)(auctionId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Finalize Auction",
        description: "The auction has finished. Confirm to withdraw the token or your funds.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

;// CONCATENATED MODULE: ./src/components/modals/auction-withdraw/index.tsx







var AuctionWithdraw = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, auctionId = param.auctionId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* auctionWithdraw */.t0)(auctionId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Auction withdraw",
        description: "The auction has finished without any bids, press confirm to withdraw the token.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/swr/infinite/dist/index.mjs
var dist = __webpack_require__(44593);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/canvas-board-generator/index.tsx



/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable react-hooks/exhaustive-deps */ 

var Canvas = (0,stitches/* styled */.zo)("canvas", {
    width: "100%",
    "&:after": {
        content: "",
        display: "block",
        paddingTop: "calc(1 * 100%);"
    }
});
var SIZE = 960;
var CanvasBoardGenerator = /*#__PURE__*/ (0,react.forwardRef)(function(param, forwardedRef) {
    var images = param.images;
    var ref = (0,react.useState)([]), img = ref[0], setImg = ref[1];
    var drawImages = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var cvs, ctx, imgSize, left, top, imgSize1, left1, top1, imgSize2, left2, top2, imgSize3, left3, top3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cvs = forwardedRef.current;
                        if (cvs) {
                            ctx = cvs.getContext("2d");
                            ctx.clearRect(0, 0, cvs.width, cvs.height);
                            ctx.imageSmoothingEnabled = false;
                            // first
                            if (img[0]) {
                                imgSize = Math.min(img[0].width, img[0].height);
                                left = (img[0].width - imgSize) / 2;
                                top = (img[0].height - imgSize) / 2;
                                ctx.drawImage(img[0], left, top, imgSize, imgSize, 0, 0, SIZE * 0.5, SIZE * 0.5);
                            }
                            // second
                            if (img[1]) {
                                imgSize1 = Math.min(img[1].width, img[1].height);
                                left1 = (img[1].width - imgSize1) / 2;
                                top1 = (img[1].height - imgSize1) / 2;
                                ctx.drawImage(img[1], left1, top1, imgSize1, imgSize1, SIZE * 0.5, 0, SIZE * 0.5, SIZE * 0.5);
                            }
                            // third
                            if (img[2]) {
                                imgSize2 = Math.min(img[2].width, img[2].height);
                                left2 = (img[2].width - imgSize2) / 2;
                                top2 = (img[2].height - imgSize2) / 2;
                                ctx.drawImage(img[2], left2, top2, imgSize2, imgSize2, 0, SIZE * 0.5, SIZE * 0.5, SIZE * 0.5);
                            }
                            // forth
                            if (img[3]) {
                                imgSize3 = Math.min(img[3].width, img[3].height);
                                left3 = (img[3].width - imgSize3) / 2;
                                top3 = (img[3].height - imgSize3) / 2;
                                ctx.drawImage(img[3], left3, top3, imgSize3, imgSize3, SIZE * 0.5, SIZE * 0.5, SIZE * 0.5, SIZE * 0.5);
                            }
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function drawImages() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var nextImages = [];
        // load images in sequence so we always insure the order is kept.
        var loadSingleImage = function(current, total, callback) {
            var image = new Image();
            image.crossOrigin = "anonymous";
            image.onload = function() {
                nextImages.push(image);
                if (current < total) {
                    loadSingleImage(current + 1, total, callback);
                }
                if (current === total) {
                    callback();
                }
            };
            image.src = images[current];
        };
        if (images.length > 0) {
            loadSingleImage(0, images.length - 1, function() {
                return setImg(nextImages);
            });
        } else {
            setImg([]);
            drawImages();
        }
    }, [
        images
    ]);
    (0,react.useEffect)(function() {
        drawImages();
    }, [
        img
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Canvas, {
        ref: forwardedRef,
        width: SIZE,
        height: SIZE,
        css: {
            backgroundColor: "$secondaryBackground"
        }
    });
});
CanvasBoardGenerator.displayName = "canvasBoardGenerator";

// EXTERNAL MODULE: ./src/components/thumbnail-board/index.tsx + 1 modules
var thumbnail_board = __webpack_require__(13707);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/lib/ipfs/adapters/infura.ts
var infura = __webpack_require__(48493);
// EXTERNAL MODULE: ./src/utils/canvas.ts
var canvas = __webpack_require__(38208);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(79618);
// EXTERNAL MODULE: ./src/utils/ipfs.ts
var ipfs = __webpack_require__(80125);
// EXTERNAL MODULE: ./src/utils/math.ts
var math = __webpack_require__(60465);
// EXTERNAL MODULE: ./src/utils/token.ts
var utils_token = __webpack_require__(56373);
;// CONCATENATED MODULE: ./src/components/modals/board-cover-edit/styles.ts


var fadeIn = (0,stitches/* keyframes */.F4)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var fadeOut = (0,stitches/* keyframes */.F4)({
    from: {
        opacity: 1
    },
    to: {
        opacity: 0
    }
});
var Overlay = (0,stitches/* styled */.zo)("div", {
    position: "absolute",
    top: 0,
    left: 0,
    width: "calc(100% - 0px)",
    height: "calc(100% - 0px)",
    zIndex: 1,
    "@media (prefers-reduced-motion: no-preference)": {
        animation: "".concat(fadeIn, " 200ms ease-out"),
        willChange: "transform",
        '&[data-state="closed"]': {
            animation: "".concat(fadeOut, " 100ms ease-out")
        }
    }
});
var Checkmark = (0,stitches/* styled */.zo)("div", {
    position: "absolute",
    bottom: 4,
    right: 4,
    zIndex: 1,
    i: {
        display: "block",
        fontSize: 18,
        fontWeight: 700,
        color: "$primaryFill"
    },
    "@media (prefers-reduced-motion: no-preference)": {
        animation: "".concat(fadeIn, " 200ms ease-out"),
        willChange: "transform",
        '&[data-state="closed"]': {
            animation: "".concat(fadeOut, " 100ms ease-out")
        }
    }
});
var Content = (0,stitches/* styled */.zo)("div", {
    display: "block",
    position: "relative",
    variants: {
        selected: {
            true: (0,_define_property/* default */.Z)({}, "& ".concat(Overlay), {
                background: "linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.1) 60%)"
            })
        }
    }
});

;// CONCATENATED MODULE: ./src/components/modals/board-cover-edit/index.tsx




/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable react/no-unused-prop-types */ /* eslint-disable react/no-array-index-key */ /* eslint-disable no-alert */ /* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-explicit-any */ 














var MediaWrapper = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4824), __webpack_require__.e(9645), __webpack_require__.e(9943), __webpack_require__.e(2255)]).then(__webpack_require__.bind(__webpack_require__, 33754));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33754)
            ];
        }
    },
    ssr: false
});
var Grid = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5151).then(__webpack_require__.bind(__webpack_require__, 75151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75151)
            ];
        }
    },
    ssr: false
});
var limit = 30;
var BoardCoverEdit = function(param) {
    var open = param.open, callback = param.callback, board = param.board;
    var _instance;
    var ref;
    var ref1 = (0,react.useState)(false), confirming = ref1[0], setConfirming = ref1[1];
    var generator = (0,react.useRef)(null);
    // which id's are selected and in which order
    var ref2 = (0,react.useState)([]), selection = ref2[0], setSelection = ref2[1];
    var startTime = (0,math/* customFloor */.o9)(Date.now(), constants/* ONE_MINUTE_MILLIS */.ud);
    var ref3 = (0,dist/* default */.ZP)(function(i, previousPageData) {
        if (previousPageData && !previousPageData.length) return null;
        if (board === null || board === void 0 ? void 0 : board.id) {
            return "/api/public/boards/".concat(board.id, "/tokens?&offset=").concat((i + 0) * limit, "&maxtime=").concat(startTime);
        }
        return null;
    }, fetcher/* tokensFetcher */.WR, {
        revalidateIfStale: false,
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshInterval: 0
    }), data = ref3.data, error = ref3.error, size = ref3.size, setSize = ref3.setSize, isValidating = ref3.isValidating;
    var items = data ? (_instance = []).concat.apply(_instance, (0,_to_consumable_array/* default */.Z)(data)) : [];
    var isLoadingInitialData = !data && !error;
    var isLoadingMore = isLoadingInitialData || size > 0 && data && typeof data[size - 1] === "undefined";
    var isEmpty = data && data.length === 0;
    var isReachingEnd = isEmpty || data && ((ref = data[data.length - 1]) === null || ref === void 0 ? void 0 : ref.length) < limit;
    var isRefreshing = isValidating && data && data.length === size;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var blob, cid;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!board) {
                            _ctx.next = 11;
                            break;
                        }
                        setConfirming(true);
                        _ctx.next = 4;
                        return (0,canvas/* canvasToBlob */._c)(generator.current);
                    case 4:
                        blob = _ctx.sent;
                        if (!blob) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 8;
                        return (0,infura/* uploadFile */.cT)(blob, true, false);
                    case 8:
                        cid = _ctx.sent;
                        // warm up IPFS gateways, and fail silently
                        fetch("/api/ipfs/warmup/".concat(cid)).catch(function(e) {
                            console.log("error on warmup", e);
                        });
                        // callback
                        if (callback) callback(true, {
                            uri: "ipfs://".concat(cid)
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (callback) callback(false);
    };
    var toggleSelection = function(selectedId) {
        var addOrRemove = selection.indexOf(selectedId) === -1;
        if (addOrRemove) {
            // add to (only up to 4 items)
            if (selection.length < 4) {
                setSelection(function(previousSelection) {
                    return (0,_to_consumable_array/* default */.Z)(previousSelection).concat([
                        selectedId
                    ]);
                });
            }
        } else {
            // remove from
            setSelection(function(previousSelection) {
                return previousSelection.filter(function(e) {
                    return e !== selectedId;
                });
            });
        }
    };
    var preview = selection.map(function(id) {
        var found = items.filter(function(i) {
            return i.id === id;
        });
        if (found) {
            return (0,utils_token/* getSmallestImageBoardPreview */._U)(found[0], ipfs/* Node.INFURA */.NB.INFURA);
        }
        return null;
    }).map(function(e) {
        return e.src;
    });
    // todo: design mobile
    // design desktop
    // save image and progress on ipfs
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Change Cover",
        description: "You can select 4 images to represent your board.",
        open: open,
        large: true,
        // onConfirm={handleConfirm}
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: {
                        position: "relative",
                        flexDirection: "column-reverse",
                        "@bp1": {
                            flexDirection: "row"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                            columns: 4,
                            space: "8px",
                            children: items.map(function(token) {
                                var isSelected = selection.indexOf(token.id) !== -1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                    onClick: function() {
                                        return toggleSelection(token.id);
                                    },
                                    selected: isSelected,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {}),
                                        isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                children: "done"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaWrapper, {
                                            token: token,
                                            inDetailView: false,
                                            labels: false
                                        })
                                    ]
                                }, "cover-".concat(token.id));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                display: "block",
                                width: "100%",
                                height: "100%",
                                "@bp1": {
                                    position: "sticky",
                                    top: 0,
                                    alignSelf: "flex-start",
                                    width: 300,
                                    height: 300,
                                    marginLeft: 16
                                }
                            },
                            children: [
                                 false && /*#__PURE__*/ 0,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasBoardGenerator, {
                                    ref: generator,
                                    images: preview
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                    css: {
                                        flexDirection: "column",
                                        padding: "$space$4"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                        unset: true,
                                        css: {
                                            textAlign: "left"
                                        },
                                        ellipsis: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: board === null || board === void 0 ? void 0 : board.title
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                !isReachingEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        margin: "$1 0"
                    },
                    horizontal: true,
                    children: isLoadingMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                        progress: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        onClick: function() {
                            return setSize(size + 1);
                        },
                        variant: "secondary",
                        disabled: isRefreshing,
                        children: "Load more"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Buttons */.E, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                        onClick: handleConfirm,
                        variant: "primary",
                        full: true,
                        css: {
                            marginBottom: "$3",
                            position: "relative"
                        },
                        disabled: confirming,
                        children: [
                            "Generate Cover",
                            confirming && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    position: "absolute",
                                    top: "50%",
                                    right: "$space$4",
                                    transform: "translateY(-50%)"
                                },
                                vertical: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                                    progress: true,
                                    small: true
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/lib/versum/index.ts + 11 modules
var versum = __webpack_require__(44980);
;// CONCATENATED MODULE: ./src/components/modals/board-create/index.tsx






/* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-explicit-any */ 




var BoardCreate = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, callback = param.callback;
    var ref = (0,react.useState)({
        title: {
            error: false,
            data: ""
        },
        description: {
            error: false,
            data: ""
        }
    }), values = ref[0], setValues = ref[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.title.data) {
            setError("title", '"Title" is missing');
            valid = false;
        }
        if (!values.description.data) {
            setError("description", '"Description" is missing');
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        (0,versum/* boardCreate */.BE)(values.title.data, values.description.data).then(function(result) {
                            if (callback) callback(result);
                        });
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Create Board",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "title",
                    label: "Title",
                    error: values.title.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        type: "text",
                        placeholder: "e.g.: Lorem ipsum",
                        onChange: function(value) {
                            return handleChange("title", value);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "description",
                    label: "Description",
                    error: values.description.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Textarea */.gx, {
                        placeholder: "e.g.: dolor sit amet",
                        value: values.description.data,
                        onChange: function(value) {
                            return handleChange("description", value);
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/board-delete/index.tsx







var BoardDelete = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, callback = param.callback, board = param.board;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!board) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        (0,versum/* boardDelete */.eo)(board.id).then(function(result) {
                            if (callback) callback(true, result);
                            if (onOpenChange) {
                                onOpenChange(false);
                            }
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (callback) callback(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Delete Board",
        description: "Are you sure you want to delete this Board?",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        confirmText: "Delete",
        canClose: false,
        warning: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

// EXTERNAL MODULE: ./src/state/modals/index.ts
var state_modals = __webpack_require__(68525);
;// CONCATENATED MODULE: ./src/components/modals/board-edit/index.tsx






/* eslint-disable no-alert */ /* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-explicit-any */ 








var BoardEdit = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, callback = param.callback, board = param.board, tempUri = param.tempUri;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)({
        title: {
            error: false,
            data: board === null || board === void 0 ? void 0 : board.title
        },
        description: {
            error: false,
            data: board === null || board === void 0 ? void 0 : board.description
        },
        // tempUri is a temp string that comes from the edit cover window
        cover: {
            error: false,
            data: tempUri || (board === null || board === void 0 ? void 0 : board.cover_uri)
        },
        privacy: {
            error: false,
            data: board === null || board === void 0 ? void 0 : board.private
        }
    }), values = ref[0], setValues = ref[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.title.data) {
            setError("title", '"Title" is missing');
            valid = false;
        }
        if (!values.description.data) {
            setError("description", '"Description" is missing');
            valid = false;
        }
        if ((board === null || board === void 0 ? void 0 : board.tokens.length) === 4 && !values.cover.data) {
            setError("cover", '"Cover" is missing');
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 6;
                            break;
                        }
                        if (!board) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 4;
                        return (0,node/* testNodeHealth */.M)();
                    case 4:
                        (0,versum/* boardModify */.aN)(board.id, values.title.data, values.description.data, values.cover.data, values.privacy.data).then(function(result) {
                            if (callback) callback(result);
                        });
                    case 5:
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    var promptEditCoverModal = function() {
        if (board) {
            var cb = function(_success, result) {
                // user cancelled
                dispatch({
                    type: state_modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                    payload: {
                        type: "board-edit",
                        board: board,
                        tempUri: result === null || result === void 0 ? void 0 : result.uri
                    }
                });
            };
            dispatch({
                type: state_modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                payload: {
                    type: "board-cover-edit",
                    board: board,
                    callback: cb
                }
            });
        }
    };
    var promptDeleteModal = function() {
        if (board) {
            var cb = function(isConfirmCallback, result) {
                if (isConfirmCallback) {
                    // user confirmed
                    if (callback) callback(result);
                    if (onOpenChange) {
                        onOpenChange(false);
                    }
                } else {
                    // user cancelled
                    dispatch({
                        type: state_modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                        payload: {
                            type: "board-edit",
                            board: board
                        }
                    });
                }
            };
            dispatch({
                type: state_modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                payload: {
                    type: "board-delete",
                    board: board,
                    callback: cb
                }
            });
        }
    };
    var images = board ? board.tokens.map(function(param) {
        var token = param.token;
        return (0,utils_token/* getSmallestImageBoardPreview */._U)(token);
    }).map(function(e) {
        return e.src;
    }) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Edit Board",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "title",
                    label: "Title",
                    error: values.title.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        type: "text",
                        placeholder: "e.g.: Lorem ipsum",
                        defaultValue: values.title.data,
                        onChange: function(value) {
                            return handleChange("title", value);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "description",
                    label: "Description",
                    error: values.description.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Textarea */.gx, {
                        placeholder: "e.g.: dolor sit amet",
                        defaultValue: values.description.data,
                        onChange: function(value) {
                            return handleChange("description", value);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "cover",
                    label: "Cover",
                    error: values.cover.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        variant: "basic",
                        onClick: promptEditCoverModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            css: {
                                display: "block",
                                width: 200,
                                height: 200
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(thumbnail_board/* ThumbnailBoard */.V, {
                                cover: values.cover.data,
                                images: images
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "settings",
                    label: "Settings",
                    error: values.privacy.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Checkbox */.XZ, {
                        value: values.privacy.data,
                        label: "Keep this board private",
                        onChange: function(value) {
                            return handleChange("privacy", value);
                        },
                        reversed: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "delete",
                    label: "Danger Zone",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        variant: "secondary",
                        onClick: promptDeleteModal,
                        full: true,
                        children: "Delete board"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
;// CONCATENATED MODULE: ./src/components/modals/error-warning/index.tsx

/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/no-explicit-any */ 




var ErrorWarning = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, message = param.message, error = param.error, callback = param.callback;
    var general = (0,es/* useSelector */.v9)(function(state) {
        return state.settings;
    }).general;
    var handleContinue = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
        if (callback) {
            callback();
        }
    };
    (0,react.useEffect)(function() {
        // if user allows for crash reports send it to sentry
        if (general.crashreport) {
            (0,esm_exports/* captureException */.Tb)(error);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Error",
        description: message,
        open: open,
        onOpenChange: handleContinue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill",
                        fontSize: 14
                    },
                    children: [
                        "Copy the error stack below and report on",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            as: "a",
                            variant: "underline",
                            href: "https://t.co/Pt1QuvBtbJ",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Discord"
                        }),
                        " ",
                        "or",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            as: "a",
                            variant: "underline",
                            href: "https://github.com/versumstudios/report-issues/issues/new?assignees=&labels=&template=bug_report.md",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Github"
                        }),
                        "."
                    ]
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Code */.EK, {
                    children: error
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/offer-accept/index.tsx








var OfferAccept = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, id = param.id, price = param.price, platformName = param.platformName, tokenKT = param.tokenKT, tokenId = param.tokenId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* offerAccept */.xs)(id, tokenKT, tokenId, platformName);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Accept Offer",
        description: "You're about to accept an offer of ".concat((0,format/* MutToTez */.QO)(price), "tez."),
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

;// CONCATENATED MODULE: ./src/components/modals/offer-cancel/index.tsx







var OfferCancel = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, offerId = param.offerId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* offerCancel */.Ne)(offerId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Cancel Offer",
        description: "You're about to cancel your offer on this token.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

;// CONCATENATED MODULE: ./src/components/modals/offer-create/index.tsx






/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-explicit-any */ 






var OfferCreate = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, tokenKT = param.tokenKT, tokenId = param.tokenId;
    var t = (0,use_intl_esm3/* default */.Z)("market");
    var ref = (0,react.useState)({
        currency: {
            error: false,
            data: null
        },
        price: {
            error: false,
            data: null
        }
    }), values = ref[0], setValues = ref[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.price.data) {
            setError("price", '"Price" is missing');
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        (0,beacon/* offerCreate */.N8)(Number(values.price.data), 1, tokenKT, tokenId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: t("offer"),
        description: "You're about to make an offer on this token.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "currency",
                    label: "Currency",
                    error: values.currency.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorCurrency, {
                        onChange: function(value) {
                            return handleChange("currency", value);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "price",
                    label: "Price",
                    tooltip: "Price of your token in XTZ",
                    error: values.price.error,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        type: "number",
                        min: 0,
                        placeholder: "e.g.: 7",
                        onChange: function(value) {
                            return handleChange("price", value);
                        }
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-easy-crop/index.module.js + 1 modules
var index_module = __webpack_require__(83913);
// EXTERNAL MODULE: ./src/components/avatar/index.tsx + 1 modules
var avatar = __webpack_require__(11422);
// EXTERNAL MODULE: ./src/components/upload/index.tsx + 4 modules
var upload = __webpack_require__(78870);
;// CONCATENATED MODULE: ./src/components/modals/avatar-edit/index.tsx



/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 







var AvatarEdit = function(param) {
    var name = param.name, path = param.path, callback = param.callback;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(), file = ref1[0], setFile = ref1[1];
    var ref2 = (0,react.useState)({
        x: 0,
        y: 0
    }), crop = ref2[0], setCrop = ref2[1];
    var ref3 = (0,react.useState)(0), rotation = ref3[0], setRotation = ref3[1];
    var ref4 = (0,react.useState)(1), zoom = ref4[0], setZoom = ref4[1];
    var ref5 = (0,react.useState)(), croppedAreaPixels = ref5[0], setCroppedAreaPixels = ref5[1];
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var onCropComplete = (0,react.useCallback)(function(_nextCroppedArea, nextCroppedAreaPixels) {
        setCroppedAreaPixels(nextCroppedAreaPixels);
    }, []);
    var reset = function() {
        setOpen(false);
        setFile(undefined);
        setLoading(false);
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var nextCroppedImage, cid, blob;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        if (!((file === null || file === void 0 ? void 0 : file.uri) && croppedAreaPixels)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 4;
                        return (0,canvas/* getCroppedImg */.m4)(file === null || file === void 0 ? void 0 : file.uri, croppedAreaPixels, rotation, 512);
                    case 4:
                        nextCroppedImage = _ctx.sent;
                        if (!nextCroppedImage) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 8;
                        return (0,infura/* uploadFile */.cT)(nextCroppedImage, true, false);
                    case 8:
                        cid = _ctx.sent;
                        if (callback) {
                            blob = URL.createObjectURL(nextCroppedImage);
                            callback({
                                blob: blob,
                                ipfs: "ipfs://".concat(cid)
                            });
                            reset();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        reset();
    };
    var handleUploadChange = function(nextFile) {
        setFile(nextFile);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ImageEdit */.GB, {
                onClick: function() {
                    return setOpen(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                    username: name,
                    path: path,
                    size: 60,
                    round: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Dialog */.Vq, {
                title: "Edit Avatar",
                description: "Recommended size 512x512px",
                open: open,
                onOpenChange: function(next) {
                    return setOpen(next);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: file ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    position: "relative",
                                    width: "100%",
                                    minHeight: 200,
                                    marginBottom: "$space$3"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                                    image: file.uri,
                                    crop: crop,
                                    rotation: rotation,
                                    zoom: zoom,
                                    aspect: 1 / 1,
                                    objectFit: "contain",
                                    onCropChange: setCrop,
                                    onCropComplete: onCropComplete,
                                    onZoomChange: setZoom,
                                    cropShape: "round",
                                    showGrid: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                                uid: "zoom",
                                label: "Zoom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Slider */.iR, {
                                    label: "zoom-slider",
                                    min: 1,
                                    max: 3,
                                    value: [
                                        zoom
                                    ],
                                    onChange: function(nextZoom) {
                                        return setZoom(nextZoom);
                                    },
                                    scrubber: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                                uid: "rotate",
                                label: "Rotation",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Slider */.iR, {
                                    label: "rotation-slider",
                                    min: 0,
                                    max: 360,
                                    step: 1,
                                    value: [
                                        rotation
                                    ],
                                    onChange: function(nextRotation) {
                                        return setRotation(nextRotation);
                                    },
                                    scrubber: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                css: {
                                    flexDirection: "column",
                                    "& > *": {
                                        marginTop: "$space$4"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        full: true,
                                        onClick: handleConfirm,
                                        disabled: loading,
                                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                                            progress: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "Confirm"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        full: true,
                                        variant: "secondary",
                                        onClick: handleCancel,
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                                uid: "image",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(upload/* Upload */.g, {
                                    onChange: handleUploadChange,
                                    restrict: constants/* UPLOAD_ALLOWED_AS_AVATAR */.$I
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    flexDirection: "column",
                                    "& > *": {
                                        marginTop: "$space$4"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    full: true,
                                    variant: "secondary",
                                    onClick: handleCancel,
                                    children: "Cancel"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modals/cover-edit/index.tsx



/* eslint-disable @next/next/no-img-element */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 






var CoverEdit = function(param) {
    var path = param.path, callback = param.callback;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(), file = ref1[0], setFile = ref1[1];
    var ref2 = (0,react.useState)({
        x: 0,
        y: 0
    }), crop = ref2[0], setCrop = ref2[1];
    var ref3 = (0,react.useState)(0), rotation = ref3[0], setRotation = ref3[1];
    var ref4 = (0,react.useState)(1), zoom = ref4[0], setZoom = ref4[1];
    var ref5 = (0,react.useState)(), croppedAreaPixels = ref5[0], setCroppedAreaPixels = ref5[1];
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var onCropComplete = (0,react.useCallback)(function(_nextCroppedArea, nextCroppedAreaPixels) {
        setCroppedAreaPixels(nextCroppedAreaPixels);
    }, []);
    var reset = function() {
        setOpen(false);
        setFile(undefined);
        setLoading(false);
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var nextCroppedImage, cid, blob;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        if (!((file === null || file === void 0 ? void 0 : file.uri) && croppedAreaPixels)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 4;
                        return (0,canvas/* getCroppedImg */.m4)(file === null || file === void 0 ? void 0 : file.uri, croppedAreaPixels, rotation, 1500);
                    case 4:
                        nextCroppedImage = _ctx.sent;
                        if (!nextCroppedImage) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 8;
                        return (0,infura/* uploadFile */.cT)(nextCroppedImage, true, false);
                    case 8:
                        cid = _ctx.sent;
                        if (callback) {
                            blob = URL.createObjectURL(nextCroppedImage);
                            callback({
                                blob: blob,
                                ipfs: "ipfs://".concat(cid)
                            });
                            reset();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        reset();
    };
    var handleUploadChange = function(nextFile) {
        setFile(nextFile);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ImageEdit */.GB, {
                css: {
                    width: "100%",
                    height: "100%"
                },
                onClick: function() {
                    return setOpen(true);
                },
                children: path && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: path,
                    alt: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Dialog */.Vq, {
                title: "Edit Cover",
                description: "Recommended size 1000x300px",
                open: open,
                onOpenChange: function(next) {
                    return setOpen(next);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: file ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    position: "relative",
                                    width: "100%",
                                    minHeight: 200,
                                    marginBottom: "$space$3"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                                    image: file.uri,
                                    crop: crop,
                                    rotation: rotation,
                                    zoom: zoom,
                                    aspect: 1000 / 300,
                                    objectFit: "contain",
                                    onCropChange: setCrop,
                                    onCropComplete: onCropComplete,
                                    onZoomChange: setZoom,
                                    // cropShape="round"
                                    showGrid: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                                uid: "zoom",
                                label: "Zoom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Slider */.iR, {
                                    label: "zoom-slider",
                                    min: 1,
                                    max: 3,
                                    value: [
                                        zoom
                                    ],
                                    onChange: function(nextZoom) {
                                        return setZoom(nextZoom);
                                    },
                                    scrubber: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                                uid: "rotate",
                                label: "Rotation",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Slider */.iR, {
                                    label: "rotation-slider",
                                    min: 0,
                                    max: 360,
                                    step: 1,
                                    value: [
                                        rotation
                                    ],
                                    onChange: function(nextRotation) {
                                        return setRotation(nextRotation);
                                    },
                                    scrubber: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                css: {
                                    flexDirection: "column",
                                    "& > *": {
                                        marginTop: "$space$4"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        full: true,
                                        onClick: handleConfirm,
                                        disabled: loading,
                                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                                            progress: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "Confirm"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        full: true,
                                        variant: "secondary",
                                        onClick: handleCancel,
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                                uid: "image",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(upload/* Upload */.g, {
                                    onChange: handleUploadChange,
                                    restrict: constants/* UPLOAD_ALLOWED_AS_AVATAR */.$I
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    flexDirection: "column",
                                    "& > *": {
                                        marginTop: "$space$4"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    full: true,
                                    variant: "secondary",
                                    onClick: handleCancel,
                                    children: "Cancel"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/state/auth/index.ts
var auth = __webpack_require__(30541);
;// CONCATENATED MODULE: ./src/components/modals/profile-edit/index.tsx



/* eslint-disable no-alert */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-undef */ /* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-explicit-any */ 







var ProfileEdit = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange;
    var dispatch = (0,es/* useDispatch */.I0)();
    var user = (0,es/* useSelector */.v9)(function(e) {
        return e.auth;
    }).user;
    var ref = (0,react.useState)((user === null || user === void 0 ? void 0 : user.screen_name) || ""), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)((user === null || user === void 0 ? void 0 : user.profile_bio) || ""), bio = ref1[0], setBio = ref1[1];
    var ref2 = (0,react.useState)(), avatar = ref2[0], setAvatar = ref2[1];
    var ref3 = (0,react.useState)(), cover = ref3[0], setCover = ref3[1];
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch({
                            type: auth/* actions.AUTH_UPDATE_PROFILE */.Nw.AUTH_UPDATE_PROFILE,
                            payload: {
                                name: name,
                                bio: bio,
                                avatar: avatar,
                                cover: cover
                            }
                        });
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Edit Profile",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        position: "relative",
                        flex: "none",
                        width: "100%",
                        height: 128,
                        marginBottom: -32
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverEdit, {
                        path: (cover === null || cover === void 0 ? void 0 : cover.blob) || (0,ipfs/* getURLFromIPFSorHTTP */.Fk)(user === null || user === void 0 ? void 0 : user.profile_banner_uri),
                        callback: function(nextCover) {
                            return setCover(nextCover);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        position: "relative",
                        flex: "none",
                        width: 64,
                        height: 64,
                        marginLeft: "$space$4",
                        borderRadius: 9999,
                        overflow: "hidden",
                        border: "2px solid $colors$primaryBackground"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarEdit, {
                        name: (user === null || user === void 0 ? void 0 : user.name) || "",
                        path: (avatar === null || avatar === void 0 ? void 0 : avatar.blob) || (0,ipfs/* getURLFromIPFSorHTTP */.Fk)(user === null || user === void 0 ? void 0 : user.profile_image_uri),
                        callback: function(nextAvatar) {
                            return setAvatar(nextAvatar);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "name",
                    label: "Name",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        placeholder: "Your Name",
                        value: name,
                        onChange: function(value) {
                            return setName(value);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "bio",
                    label: "Bio",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Textarea */.gx, {
                        placeholder: "Your Bio",
                        value: bio,
                        onChange: function(value) {
                            return setBio(value);
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/swap-cancel/index.tsx







var SwapCancel = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, swapId = param.swapId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* swapCancel */.wF)(swapId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Cancel Swap",
        description: "You're about to cancel a swap on this token.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

;// CONCATENATED MODULE: ./src/components/modals/swap-collect/index.tsx






/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-explicit-any */ 




var SwapCollect = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, swapId = param.swapId, swapPrice = param.swapPrice, swapMaxQuantity = param.swapMaxQuantity, creatorsTotal = param.creatorsTotal;
    var ref = (0,react.useState)({
        quantity: {
            error: false,
            data: 1
        }
    }), values = ref[0], setValues = ref[1];
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.quantity.data) {
            setError("quantity", '"Quantity" is missing');
            valid = false;
        }
        if (values.quantity.data < 1 || values.quantity.data > swapMaxQuantity) {
            setError("quantity", '"Quantity" needs to be between 1 and '.concat(swapMaxQuantity, "."));
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        (0,beacon/* swapCollect */.RF)(swapId, swapPrice * values.quantity.data, Number(values.quantity.data), creatorsTotal);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Collect",
        description: "You're about to collect this token.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                uid: "quantity",
                label: "Quantity",
                tooltip: "How many editions to collect",
                error: values.quantity.error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                    type: "number",
                    min: 1,
                    max: swapMaxQuantity,
                    placeholder: "e.g.: 1",
                    value: values.quantity.data,
                    onChange: function(value) {
                        return handleChange("quantity", value);
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/swap-conclude/index.tsx







var SwapConclude = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, swapId = param.swapId;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* swapCancel */.wF)(swapId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Complete Swap",
        description: "This swap has expired.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

;// CONCATENATED MODULE: ./src/components/modals/swap-create/index.tsx






/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-explicit-any */ 







var MODE;
(function(MODE) {
    MODE["SIMPLE"] = "simple";
    MODE["TIME_LIMITED"] = "time-limited";
    MODE["ADVANCED"] = "advanced";
})(MODE || (MODE = {}));
var SwapCreate = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, platformName = param.platformName, tokenKT = param.tokenKT, tokenId = param.tokenId, tokensOwned = param.tokensOwned, creatorsTotal = param.creatorsTotal;
    var ref = (0,react.useState)(false), limit = ref[0], setLimit = ref[1];
    var ref1 = (0,react.useState)(false), burn = ref1[0], setBurn = ref1[1];
    var ref2 = (0,react.useState)(MODE.SIMPLE), currentMode = ref2[0], setCurrentMode = ref2[1];
    var ref3 = (0,react.useState)({
        quantity: {
            error: false,
            data: tokensOwned && tokensOwned > 1 ? "" : tokensOwned
        },
        currency: {
            error: false,
            data: null
        },
        price: {
            error: false,
            data: ""
        },
        start: {
            error: false,
            data: ""
        },
        end: {
            error: false,
            data: ""
        },
        duration: {
            error: false,
            data: ""
        },
        limit: {
            error: false,
            data: ""
        }
    }), values = ref3[0], setValues = ref3[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var handleChangeMode = function(nextMode) {
        setCurrentMode(nextMode);
        handleChange("price", "");
        handleChange("start", "");
        handleChange("end", "");
        handleChange("duration", "");
        handleChange("limit", "");
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.quantity.data) {
            setError("quantity", '"Quantity" is missing');
            valid = false;
        }
        if (Math.round(values.quantity.data) > Number(tokensOwned)) {
            setError("quantity", "You only own ".concat(tokensOwned, " tokens"));
            valid = false;
        }
        if (currentMode === MODE.SIMPLE) {
            if (Math.round(values.quantity.data) < 1) {
                setError("quantity", "Minimum quantity 1 tokens");
                valid = false;
            }
            if (!values.price.data) {
                setError("price", '"Price" is missing');
                valid = false;
            }
        } else if (currentMode === MODE.TIME_LIMITED) {
            if (Math.round(values.quantity.data) < 1) {
                setError("quantity", "Minimum quantity 1 tokens");
                valid = false;
            }
            if (!values.price.data) {
                setError("price", '"Price" is missing');
                valid = false;
            }
            if (!values.duration.data) {
                setError("duration", '"Duration" is missing');
                valid = false;
            }
            if (Number(values.duration.data) < 2) {
                setError("duration", 'Min "Duration" value is 2h');
                valid = false;
            }
            if (Number(values.duration.data) > 24 * 7) {
                setError("duration", 'Max "Duration" value is one-week (168h)');
                valid = false;
            }
        } else if (currentMode === MODE.ADVANCED) {
            if (Math.round(values.quantity.data) < 2) {
                setError("quantity", "Minimum quantity 2 tokens");
                valid = false;
            }
            if (!values.start.data) {
                setError("start", '"Start price" is missing');
                valid = false;
            }
            if (!values.end.data) {
                setError("end", '"End price" is missing');
                valid = false;
            }
            if (Number(values.start.data) > Number(values.end.data)) {
                setError("end", '"End price" can\'t be smaller that "Start price"');
                valid = false;
            }
            // check if increment is divisible
            var range = new (bignumber_default())(Number(values.end.data) - Number(values.start.data)).dividedBy(Number(values.quantity.data) - 1).toNumber();
            if (range * Number(values.quantity.data) !== Number(values.end.data)) {
                setError("start", "Range between start and end price not possible.");
                valid = false;
            }
        }
        if (limit) {
            if (!values.limit.data) {
                setError("limit", '"Editions per transaction" is missing');
                valid = false;
            }
            if (Math.round(values.limit.data) < 1) {
                setError("limit", '"Editions per transaction" should be bigger than 1');
                valid = false;
            }
            if (Math.round(values.limit.data) > Number(tokensOwned)) {
                setError("limit", "You only own ".concat(tokensOwned, " tokens"));
                valid = false;
            }
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        if (currentMode === MODE.SIMPLE) {
                            (0,beacon/* swapCreate */.hT)(false, limit ? Number(values.limit.data) : 0, (0,format/* TezToMut */.gu)(values.price.data), (0,format/* TezToMut */.gu)(values.price.data), Number(values.quantity.data), null, platformName, tokenKT, tokenId, creatorsTotal);
                        } else if (currentMode === MODE.TIME_LIMITED) {
                            (0,beacon/* swapCreate */.hT)(burn, limit ? Number(values.limit.data) : 0, (0,format/* TezToMut */.gu)(values.price.data), (0,format/* TezToMut */.gu)(values.price.data), Number(values.quantity.data), Number(values.duration.data), platformName, tokenKT, tokenId, creatorsTotal);
                        } else if (currentMode === MODE.ADVANCED) {
                            (0,beacon/* swapCreate */.hT)(false, limit ? Number(values.limit.data) : 0, (0,format/* TezToMut */.gu)(values.start.data), (0,format/* TezToMut */.gu)(values.end.data), Number(values.quantity.data), null, platformName, tokenKT, tokenId, creatorsTotal);
                        }
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Create Swap",
        description: "You're about to swap this token.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* RadioGroup */.Ee, {
                    value: currentMode,
                    onChange: handleChangeMode,
                    data: [
                        {
                            key: MODE.SIMPLE,
                            label: "Simple"
                        },
                        {
                            key: MODE.TIME_LIMITED,
                            label: "Time-limited"
                        },
                        {
                            key: MODE.ADVANCED,
                            label: "Advanced"
                        }, 
                    ]
                }),
                tokensOwned && tokensOwned > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "quantity",
                            label: "Quantity",
                            error: values.quantity.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "number",
                                min: currentMode === MODE.ADVANCED ? 2 : 1,
                                max: tokensOwned,
                                value: values.quantity.data,
                                placeholder: "e.g.: 1",
                                onChange: function(value) {
                                    return handleChange("quantity", value);
                                }
                            })
                        }),
                        Number(values.quantity.data) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "limit-toggle",
                            label: "Limit per transaction",
                            tooltip: "Limits the amount of editions that can be collected per transaction.",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Toggle */.ZD, {
                                value: limit,
                                onChange: function(nextValue) {
                                    return setLimit(nextValue);
                                }
                            })
                        }),
                        limit && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "limit",
                            label: "Editions per transaction",
                            tooltip: "Limits the amount of editions that can be collected per transaction.",
                            error: values.limit.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "number",
                                min: 0,
                                placeholder: "e.g.: 2",
                                value: values.limit.data,
                                onChange: function(value) {
                                    return handleChange("limit", value);
                                }
                            })
                        })
                    ]
                }),
                (currentMode === MODE.SIMPLE || currentMode === MODE.TIME_LIMITED) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "currency",
                            label: "Currency",
                            error: values.currency.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorCurrency, {
                                onChange: function(value) {
                                    return handleChange("currency", value);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "price",
                            label: "Price",
                            error: values.price.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "number",
                                min: 0,
                                placeholder: "e.g.: 7",
                                onChange: function(value) {
                                    return handleChange("price", value);
                                }
                            })
                        })
                    ]
                }),
                currentMode === MODE.TIME_LIMITED && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "duration",
                            label: "Time (hours)",
                            error: values.duration.error,
                            tooltip: "Duration for the swap in hours.",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "number",
                                min: 2,
                                max: 24 * 7,
                                placeholder: "e.g.: 24",
                                value: values.duration.data,
                                onChange: function(value) {
                                    return handleChange("duration", value);
                                }
                            })
                        }),
                        Number(values.quantity.data) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "burn",
                            label: "Burn on end",
                            tooltip: "When the swap ends all remaining tokens will be burned.",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Toggle */.ZD, {
                                value: burn,
                                onChange: function(nextValue) {
                                    return setBurn(nextValue);
                                }
                            })
                        }),
                        burn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    css: {
                                        fontSize: 14,
                                        fontWeight: 700
                                    },
                                    children: "⚠️ Warning"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    css: {
                                        fontSize: 14,
                                        color: "$secondaryFill"
                                    },
                                    children: "This option will burn any unsold tokens when the time is reached. Cancelling the swap also triggers the burn. Make sure you're happy with the price."
                                })
                            ]
                        })
                    ]
                }),
                currentMode === MODE.ADVANCED && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "currency",
                            label: "Currency",
                            error: values.currency.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorCurrency, {
                                onChange: function(value) {
                                    return handleChange("currency", value);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "start",
                            label: "Start price",
                            error: values.start.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "number",
                                min: 0,
                                placeholder: "e.g.: 1",
                                value: values.start.data,
                                onChange: function(value) {
                                    return handleChange("start", value);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "end",
                            label: "End price",
                            error: values.end.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "number",
                                min: 0,
                                placeholder: "e.g.: 10",
                                value: values.end.data,
                                onChange: function(value) {
                                    return handleChange("end", value);
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/swap-slippage/index.tsx



/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-explicit-any */ 






var SLIPPAGE;
(function(SLIPPAGE) {
    SLIPPAGE["ZERO"] = "0";
    SLIPPAGE["ONE"] = "1";
    SLIPPAGE["TWO"] = "2";
    SLIPPAGE["FOUR"] = "4";
    SLIPPAGE["EIGHT"] = "8";
})(SLIPPAGE || (SLIPPAGE = {}));
var SwapSlippage = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, swapId = param.swapId, startPrice = param.startPrice, endPrice = param.endPrice, amount = param.amount, amountLeft = param.amountLeft, creatorsTotal = param.creatorsTotal;
    var ref = (0,react.useState)(SLIPPAGE.ZERO), slippage = ref[0], setSlippage = ref[1];
    var current = (0,math/* calculateAdvancedSwapPrice */.Sj)(startPrice, endPrice, amount, amountLeft);
    var withSlippage = (0,math/* calculateAdvancedSwapPrice */.Sj)(startPrice, endPrice, amount, amountLeft, Number(slippage));
    var handleChangeMode = function(nextMode) {
        setSlippage(nextMode);
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        (0,beacon/* swapCollect */.RF)(swapId, withSlippage, 1, creatorsTotal);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Advanced Swap",
        description: "Adjust swap slippage",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "slippage",
                    label: "Slippage",
                    tooltip: "Slippage multiplier. The higher the better",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* RadioGroup */.Ee, {
                                value: slippage,
                                onChange: handleChangeMode,
                                data: [
                                    {
                                        key: SLIPPAGE.ZERO,
                                        label: "x0"
                                    },
                                    {
                                        key: SLIPPAGE.ONE,
                                        label: "x1"
                                    },
                                    {
                                        key: SLIPPAGE.TWO,
                                        label: "x2"
                                    },
                                    {
                                        key: SLIPPAGE.FOUR,
                                        label: "x4"
                                    },
                                    {
                                        key: SLIPPAGE.EIGHT,
                                        label: "x8"
                                    }, 
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                                css: {
                                    color: "$secondaryFill",
                                    fontSize: 14
                                },
                                children: [
                                    "Read more",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        as: "a",
                                        variant: "underline",
                                        href: "https://docs.versum.xyz/faq/slippage/",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "here"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "current",
                    label: "Current price",
                    tooltip: "This is the current price",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        type: "number",
                        value: (0,format/* MutToTez */.QO)(current),
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                    uid: "with-slippage",
                    label: "Price with slippage",
                    tooltip: "This is the adjusted price",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                        type: "number",
                        value: (0,format/* MutToTez */.QO)(withSlippage),
                        disabled: true
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/token-burn/index.tsx






/* eslint-disable camelcase */ /* eslint-disable @typescript-eslint/no-explicit-any */ 





var TokenBurn = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, platformName = param.platformName, tokenKT = param.tokenKT, tokenId = param.tokenId, tokensOwned = param.tokensOwned;
    var account = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    }).account;
    var ref = (0,react.useState)({
        quantity: {
            error: false,
            data: tokensOwned && tokensOwned > 1 ? null : tokensOwned
        }
    }), values = ref[0], setValues = ref[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.quantity.data) {
            setError("quantity", '"Quantity" is missing');
            valid = false;
        }
        if (Math.round(values.quantity.data) > Number(tokensOwned)) {
            setError("quantity", "You only own ".concat(tokensOwned, " tokens"));
            valid = false;
        }
        if (Math.round(values.quantity.data) < 1) {
            setError("quantity", "Minimum quantity 1 tokens");
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(validate() && account && platformName && tokenKT && tokenId)) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        (0,beacon/* burn */.By)(account.address, Number(values.quantity.data), platformName, tokenKT, tokenId);
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Burn Token",
        description: "You're about to burn this token.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {
            children: tokensOwned && tokensOwned > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                uid: "quantity",
                label: "Quantity",
                tooltip: "How many editions are you transfering",
                error: values.quantity.error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                    type: "number",
                    placeholder: "e.g.: 1",
                    min: 1,
                    max: tokensOwned,
                    value: values.quantity.data || "",
                    onChange: function(value) {
                        return handleChange("quantity", value);
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/circle-button-add/styles.ts



var Label = (0,stitches/* styled */.zo)("label", (0,_define_property/* default */.Z)({
    display: "inline-flex",
    alignItems: "center",
    color: "$secondaryFill",
    fontSize: 14,
    cursor: "pointer"
}, "& ".concat(index_es/* IconButton */.hU), {
    marginRight: 8
}));

;// CONCATENATED MODULE: ./src/components/circle-button-add/index.tsx



var CircleButtonAdd = function(param) {
    var label = param.label, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {
        return null;
    } : _onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        onPointerUp: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* IconButton */.hU, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: "add"
                })
            }),
            label
        ]
    });
};

// EXTERNAL MODULE: ./src/state/global/index.ts
var global = __webpack_require__(64275);
;// CONCATENATED MODULE: ./src/components/modals/token-save/index.tsx




/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-explicit-any */ 







// TODO: this might need some refactoring to avoid calling FetchUserBoards on first time
var TokenSave = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, viewer = param.viewer, tokenId = param.tokenId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeBoards = (0,es/* useSelector */.v9)(function(e) {
        return e.global.boards;
    });
    var ref = (0,react.useState)([]), boards = ref[0], setBoards = ref[1];
    var FetchUserBoards = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var boardsContainingToken, nextBoards;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,versum/* GetUserBoardsContainingToken */.bu)(viewer, tokenId);
                    case 2:
                        boardsContainingToken = _ctx.sent;
                        nextBoards = storeBoards.map(function(b) {
                            var selected = boardsContainingToken.token_lists.find(function(e) {
                                return e.id === b.id;
                            }) !== undefined;
                            return {
                                id: b.id,
                                selected: selected,
                                label: b.title
                            };
                        });
                        setBoards(nextBoards);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function FetchUserBoards() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirm = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    var handleNewBoard = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var callback;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        callback = function() {
                            var user = {
                                id: viewer
                            };
                            dispatch({
                                type: global/* actions.GLOBAL_GET_BOARDS */.Nw.GLOBAL_GET_BOARDS,
                                payload: user
                            });
                            dispatch({
                                type: state_modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                                payload: {
                                    type: "token-save",
                                    tokenId: tokenId,
                                    viewer: viewer
                                }
                            });
                        };
                        dispatch({
                            type: state_modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                            payload: {
                                type: "board-create",
                                callback: callback
                            }
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleNewBoard() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleTokenAdd = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(boardId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,versum/* boardTokenAdd */.XS)(boardId, tokenId);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTokenAdd(boardId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleTokenRemove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(boardId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,versum/* boardTokenRemove */.ce)(boardId, tokenId);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTokenRemove(boardId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChange = function(id, selected) {
        var board = boards.find(function(e) {
            return e.id === id;
        });
        if (board) {
            var index = boards.indexOf(board);
            var items = (0,_to_consumable_array/* default */.Z)(boards);
            var item = items[index];
            item.selected = selected;
            items[index] = item;
            setBoards(items);
            if (selected) {
                handleTokenAdd(id);
            } else {
                handleTokenRemove(id);
            }
        }
    };
    (0,react.useEffect)(function() {
        FetchUserBoards();
    }, [
        storeBoards
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Add to Board",
        description: "You can add the token to multiple boards.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                boards.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        flexDirection: "column",
                        height: boards.length >= 4 ? 180 : boards.length * 50 + 2,
                        overflowY: "auto",
                        borderRadius: 5,
                        border: "1px solid $colors$primaryBorder"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            flexDirection: "column",
                            "&>*:last-child": {
                                borderBottom: "none"
                            }
                        },
                        children: boards.map(function(board) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                vertical: true,
                                css: {
                                    height: 50,
                                    padding: "0 $space$3",
                                    cursor: "pointer",
                                    borderBottom: "1px solid $colors$primaryBorder",
                                    "&:hover": {
                                        backgroundColor: "$secondaryBackground"
                                    },
                                    "&:focus-within": {
                                        backgroundColor: "$secondaryBackground"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Checkbox */.XZ, {
                                    reversed: true,
                                    label: board.label,
                                    value: board.selected,
                                    onChange: function(value) {
                                        return handleChange(board.id, value);
                                    },
                                    css: {
                                        width: "100%",
                                        height: "100%"
                                    }
                                })
                            }, board.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        margin: "$space$3 0"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleButtonAdd, {
                        label: "New Board",
                        onClick: handleNewBoard
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@taquito/utils/dist/taquito-utils.es6.js
var taquito_utils_es6 = __webpack_require__(4118);
// EXTERNAL MODULE: ./src/utils/validation.ts
var validation = __webpack_require__(6146);
;// CONCATENATED MODULE: ./src/components/modals/token-transfer/index.tsx







/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-explicit-any */ 







var TRANSFER_MODE;
(function(TRANSFER_MODE) {
    TRANSFER_MODE["SINGLE"] = "single";
    TRANSFER_MODE["MULTIPLE"] = "multiple";
})(TRANSFER_MODE || (TRANSFER_MODE = {}));
var TokenTransfer = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, platformName = param.platformName, tokenKT = param.tokenKT, tokenId = param.tokenId, tokensOwned = param.tokensOwned;
    var account = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    }).account;
    var ref = (0,react.useState)(TRANSFER_MODE.SINGLE), transferMode = ref[0], setTransferMode = ref[1];
    var ref1 = (0,react.useState)({
        // single user
        wallet: {
            error: false,
            data: null
        },
        quantity: {
            error: false,
            data: tokensOwned && tokensOwned > 1 ? null : tokensOwned
        },
        // multiple users
        wallets: {
            error: false,
            data: ""
        },
        processed: {
            error: false,
            data: []
        }
    }), values = ref1[0], setValues = ref1[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var handleProcessedChange = function(index, wallet, quantity) {
        var copy = (0,_to_consumable_array/* default */.Z)(values.processed.data);
        if (copy[index]) {
            copy[index].wallet = wallet;
            copy[index].quantity = Number(quantity);
        }
        handleChange("processed", copy);
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (transferMode === TRANSFER_MODE.SINGLE) {
            if (!values.quantity.data) {
                // validate single user transaction
                setError("quantity", '"Quantity" is missing');
                valid = false;
            }
            if (Math.round(values.quantity.data) > Number(tokensOwned)) {
                setError("quantity", "You only own ".concat(tokensOwned, " tokens"));
                valid = false;
            }
            if (Math.round(values.quantity.data) < 1) {
                setError("quantity", "Minimum quantity 1 tokens");
                valid = false;
            }
            if (!values.wallet.data) {
                setError("wallet", '"Wallet" is missing');
                valid = false;
            }
            // if (values.wallet.data.indexOf('.tez') !== -1) {
            //   // '.tez wallet found. getting address');
            //   const address = await getAddressFromDomain(values.wallet.data);
            //   if (address !== values.wallet.data) {
            //     // ('received address is different that whats on the state. Update state to', address);
            //     if (validateAddress(address) !== 3) {
            //       setError('recipient', 'Address is invalid.');
            //       valid = false;
            //     } else {
            //       handleChange('recipient', address);
            //       valid = true;
            //     }
            //   }
            // }
            if ((0,taquito_utils_es6/* validateAddress */.YN)(values.wallet.data) !== 3) {
                setError("wallet", '"Address" is invalid.');
                valid = false;
            }
        }
        if (transferMode === TRANSFER_MODE.MULTIPLE) {
            if (!values.wallets.data) {
                setError("wallets", '"Wallets" is missing');
                valid = false;
            }
        }
        var sum = values.processed.data.reduce(function(acc, param) {
            var quantity = param.quantity;
            return acc + quantity;
        }, 0);
        if (tokensOwned && sum > tokensOwned) {
            setError("processed", "You only own ".concat(tokensOwned, " tokens"));
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(validate() && account && platformName && tokenId)) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,node/* testNodeHealth */.M)();
                    case 3:
                        // single
                        if (transferMode === TRANSFER_MODE.SINGLE) {
                            (0,beacon/* transfer */.re)(account.address, [
                                {
                                    wallet: values.wallet.data,
                                    quantity: Number(values.quantity.data)
                                }
                            ], platformName, tokenKT, tokenId);
                        }
                        // multiple
                        if (transferMode === TRANSFER_MODE.MULTIPLE) {
                            (0,beacon/* transfer */.re)(account.address, values.processed.data, platformName, tokenKT, tokenId);
                        }
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    // receives an array of wallets and manually adds them
    var handleProcess = function(wallets) {
        handleChange("processed", (0,validation/* removeDuplicates */.R1)(wallets).map(function(wallet) {
            return {
                wallet: wallet,
                quantity: 1
            };
        }));
    };
    (0,react.useEffect)(function() {
        handleProcess(values.wallets.data.split("\n"));
    }, [
        values.wallets.data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Transfer Token",
        description: "You own ".concat(tokensOwned, " editions of this token."),
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.V, {
            children: [
                tokensOwned && tokensOwned > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* RadioGroup */.Ee, {
                    value: transferMode,
                    onChange: function(value) {
                        return setTransferMode(value);
                    },
                    data: [
                        {
                            key: TRANSFER_MODE.SINGLE,
                            label: "Single User"
                        },
                        {
                            key: TRANSFER_MODE.MULTIPLE,
                            label: "Multiple Users"
                        }, 
                    ]
                }),
                (transferMode === TRANSFER_MODE.SINGLE || tokensOwned && tokensOwned === 1) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        tokensOwned && tokensOwned > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "quantity",
                            label: "Quantity",
                            error: values.quantity.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "number",
                                placeholder: "e.g.: 1",
                                min: 1,
                                max: tokensOwned,
                                value: values.quantity.data || "",
                                onChange: function(value) {
                                    return handleChange("quantity", value);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "wallet",
                            label: "Wallet",
                            error: values.wallet.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Input */.II, {
                                type: "text",
                                placeholder: "e.g.: tz1keax...",
                                onChange: function(value) {
                                    return handleChange("wallet", value);
                                }
                            })
                        })
                    ]
                }),
                transferMode === TRANSFER_MODE.MULTIPLE && tokensOwned && tokensOwned > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "wallets",
                            label: "Wallets",
                            tooltip: "One wallet per line",
                            error: values.wallets.error,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Textarea */.gx, {
                                placeholder: "e.g.: tz1keax...",
                                value: values.wallets.data,
                                onChange: function(value) {
                                    return handleChange("wallets", value);
                                }
                            })
                        }),
                        values.processed.data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                            uid: "processed",
                            label: "Processed Wallets",
                            error: values.processed.error,
                            children: values.processed.data.map(function(pair, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                    css: {
                                        marginBottom: "$space$4"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* TextNumberPair */._I, {
                                        address: pair.wallet,
                                        value: pair.quantity,
                                        editable: false,
                                        onChange: function(value, percentage) {
                                            return handleProcessedChange(index, value, percentage);
                                        }
                                    })
                                }, pair.wallet);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-block/index.tsx



var UserBlock = function(param) {
    var username = param.username, open = param.open, onOpenChange = param.onOpenChange;
    var handleConfirm = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Block User",
        description: "".concat(username, " won't be able to find your profile. Versum won't let them know you blocked them."),
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {})
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/follow-user-button/index.tsx + 1 modules
var follow_user_button = __webpack_require__(51288);
// EXTERNAL MODULE: ./src/utils/user.ts
var utils_user = __webpack_require__(12857);
;// CONCATENATED MODULE: ./src/components/modals/user-followers/styles.ts

var styles_Content = (0,stitches/* styled */.zo)("div", {
    marginTop: 16,
    maxHeight: "60vh",
    overflowY: "auto",
    "@bp1": {
        height: 300,
        maxHeight: "50vh"
    }
});
var User = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "$space$4 0"
});
var Profile = (0,stitches/* styled */.zo)("div", {
    display: "flex"
});
var Info = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
    "& > *": {
        lineHeight: 1,
        fontSize: 14,
        margin: 0,
        marginBottom: 4
    }
});

;// CONCATENATED MODULE: ./src/components/modals/user-followers/index.tsx












var user_followers_fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.users;
    });
};
var UserFollowers = function(param) {
    var userid = param.userid, viewer = param.viewer, open = param.open, onOpenChange = param.onOpenChange;
    var _instance;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,dist/* default */.ZP)(function(i, previousPageData) {
        if (previousPageData && !previousPageData.length) return null;
        return "/api/public/user/".concat(userid, "/followers?viewer=").concat(viewer, "&offset=").concat((i + 0) * constants/* API_LIMIT_USER_FOLLOWERS */.ZC);
    }, user_followers_fetcher, {
        revalidateIfStale: false,
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshInterval: 0
    }), data = ref1.data, error = ref1.error, size = ref1.size, setSize = ref1.setSize;
    var items = data ? (_instance = []).concat.apply(_instance, (0,_to_consumable_array/* default */.Z)(data)) : [];
    var isLoadingInitialData = !data && !error;
    var isLoadingMore = isLoadingInitialData || size > 0 && data && typeof data[size - 1] === "undefined";
    var isEmpty = data && data.length === 0;
    var isReachingEnd = isEmpty || data && ((ref = data[data.length - 1]) === null || ref === void 0 ? void 0 : ref.length) < constants/* API_LIMIT_USER_FOLLOWERS */.ZC;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Followers",
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Content, {
            children: [
                !isLoadingInitialData && items.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill"
                    },
                    children: "No data to display"
                }),
                items.map(function(user) {
                    var versumScreenName = (0,utils_user/* getScreenName */.GG)(user.verified_on_chain, user.screen_name, user.id, user.name);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(User, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/user/".concat(user.id, "/created"),
                                locale: router.locale,
                                prefetch: false,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Profile, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                                username: user.id,
                                                path: (0,ipfs/* getURLFromIPFSorHTTP */.Fk)(user.profile_image_uri),
                                                size: 32
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: versumScreenName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                                        unset: true,
                                                        css: {
                                                            color: "$secondaryFill"
                                                        },
                                                        children: user.name
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, user.id),
                            viewer !== user.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(follow_user_button/* FollowUserButton */.c, {
                                viewer: viewer,
                                userId: user.id,
                                isFollowing: user.followedByMe.length > 0
                            })
                        ]
                    }, user.id);
                }),
                !isReachingEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        padding: "$1 0"
                    },
                    horizontal: true,
                    children: isLoadingMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                        progress: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        onClick: function() {
                            return setSize(size + 1);
                        },
                        variant: "secondary",
                        children: "Load more"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-following/styles.ts

var user_following_styles_Content = (0,stitches/* styled */.zo)("div", {
    marginTop: 16,
    maxHeight: "60vh",
    overflowY: "auto",
    "@bp1": {
        height: 300,
        maxHeight: "50vh"
    }
});
var styles_User = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "$space$4 0"
});
var styles_Profile = (0,stitches/* styled */.zo)("div", {
    display: "flex"
});
var styles_Info = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
    "& > *": {
        lineHeight: 1,
        fontSize: 14,
        margin: 0,
        marginBottom: 4
    }
});

;// CONCATENATED MODULE: ./src/components/modals/user-following/index.tsx












var user_following_fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.users;
    });
};
var UserFollowing = function(param) {
    var userid = param.userid, viewer = param.viewer, open = param.open, onOpenChange = param.onOpenChange;
    var _instance;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,dist/* default */.ZP)(function(i, previousPageData) {
        if (previousPageData && !previousPageData.length) return null;
        return "/api/public/user/".concat(userid, "/following?viewer=").concat(viewer, "&offset=").concat((i + 0) * constants/* API_LIMIT_USER_FOLLOWING */.be);
    }, user_following_fetcher, {
        revalidateIfStale: false,
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshInterval: 0
    }), data = ref1.data, error = ref1.error, size = ref1.size, setSize = ref1.setSize;
    var items = data ? (_instance = []).concat.apply(_instance, (0,_to_consumable_array/* default */.Z)(data)) : [];
    var isLoadingInitialData = !data && !error;
    var isLoadingMore = isLoadingInitialData || size > 0 && data && typeof data[size - 1] === "undefined";
    var isEmpty = data && data.length === 0;
    var isReachingEnd = isEmpty || data && ((ref = data[data.length - 1]) === null || ref === void 0 ? void 0 : ref.length) < constants/* API_LIMIT_USER_FOLLOWING */.be;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Following",
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_following_styles_Content, {
            children: [
                !isLoadingInitialData && items.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill"
                    },
                    children: "No data to display"
                }),
                items.map(function(u) {
                    var versumScreenName = (0,utils_user/* getScreenName */.GG)(u.verified_on_chain, u.screen_name, u.id, u.name);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_User, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/user/".concat(u.id, "/created"),
                                locale: router.locale,
                                prefetch: false,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Profile, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                                username: u.id,
                                                path: (0,ipfs/* getURLFromIPFSorHTTP */.Fk)(u.profile_image_uri),
                                                size: 32
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Info, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: versumScreenName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                                        unset: true,
                                                        css: {
                                                            color: "$secondaryFill"
                                                        },
                                                        children: u.name
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, u.id),
                            viewer !== u.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(follow_user_button/* FollowUserButton */.c, {
                                viewer: viewer,
                                userId: u.id,
                                isFollowing: u.followedByMe.length > 0
                            })
                        ]
                    }, u.id);
                }),
                !isReachingEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        padding: "$1 0"
                    },
                    horizontal: true,
                    children: isLoadingMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                        progress: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        onClick: function() {
                            return setSize(size + 1);
                        },
                        variant: "secondary",
                        children: "Load more"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-radio-group/dist/index.module.js
var dist_index_module = __webpack_require__(43653);
// EXTERNAL MODULE: ./src/state/settings/index.ts
var settings = __webpack_require__(92089);
;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/browser-preview.tsx



var BrowserPreview = function(param) {
    var layout = param.layout, info = param.info, market = param.market, labels = param.labels;
    var renderType = function() {
        switch(layout){
            case constants/* FEED_LAYOUT.MASONRY */.Gf.MASONRY:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Masonry */.Rk, {
                    info: info,
                    market: market,
                    labels: labels
                });
            case constants/* FEED_LAYOUT.GRID */.Gf.GRID:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Grid */.rj, {
                    info: info,
                    market: market,
                    labels: labels
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Vertical */.we, {
                    info: info,
                    market: market,
                    labels: labels
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            width: "100%",
            backgroundColor: "$secondaryBackground"
        },
        horizontal: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
            css: {
                marginTop: 32,
                height: 150,
                overflow: "hidden"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BrowserFrame */.AK, {
                children: renderType()
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/radio-item/styles.ts

var Radio = (0,stitches/* styled */.zo)("div", {
    width: 20,
    height: 20,
    backgroundColor: "$primaryBorder",
    borderRadius: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var Indicator = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 10,
    height: 10,
    borderRadius: 9999,
    backgroundColor: "$secondaryFill"
});
var Container = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    cursor: "pointer",
    border: "1px solid $colors$primaryBorder",
    padding: "$space$3",
    borderRadius: 5,
    "&:hover": {
        border: "1px solid $colors$secondaryBorder"
    },
    "&:focus": {
        border: "1px solid $colors$secondaryFill",
        outline: 0
    }
});

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/radio-item/index.tsx




var RadioItem = function(props) {
    var value = props.value, label = props.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Item */.ck, {
        value: value,
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Indicator */.z$, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Indicator, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill",
                        marginLeft: "$space$4"
                    },
                    children: label
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/info.tsx








var info_Info = function(param) {
    var values = param.values, handleChange = param.handleChange, handleStep = param.handleStep;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleValueChange = function(nextValue) {
        if (handleChange) {
            handleChange("info", nextValue === "on");
        }
        dispatch({
            type: settings/* actions.SETTINGS_CHANGE_APPEARANCE_INFO */.Nw.SETTINGS_CHANGE_APPEARANCE_INFO,
            payload: nextValue === "on"
        });
    };
    var handleClick = function() {
        handleValueChange(values.info ? "on" : "off");
        if (handleStep) handleStep(+1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserPreview, (0,_object_spread/* default */.Z)({}, values)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    padding: "$space$3",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        css: {
                            textAlign: "center"
                        },
                        children: "Info"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 14,
                            textAlign: "center"
                        },
                        children: "Display token title and author"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Root */.fC, {
                        value: values.info ? "on" : "off",
                        onValueChange: handleValueChange,
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                width: "100%",
                                flexDirection: "column",
                                "&>*": {
                                    marginBottom: "$space$4",
                                    "&:last-child": {
                                        marginBottom: "unset"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "on",
                                    label: "Enable"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "off",
                                    label: "Disable"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    padding: "$space$3",
                    justifyContent: "space-between"
                },
                vertical: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 12
                        },
                        children: "2 / 5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "simple",
                                onClick: function() {
                                    return handleStep && handleStep(-1);
                                },
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "secondary",
                                onClick: handleClick,
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/labels.tsx








var Labels = function(param) {
    var values = param.values, handleChange = param.handleChange, handleStep = param.handleStep;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleValueChange = function(nextValue) {
        if (handleChange) {
            handleChange("labels", nextValue === "on");
        }
        dispatch({
            type: settings/* actions.SETTINGS_CHANGE_APPEARANCE_LABELS */.Nw.SETTINGS_CHANGE_APPEARANCE_LABELS,
            payload: nextValue === "on"
        });
    };
    var handleClick = function() {
        handleValueChange(values.labels ? "on" : "off");
        if (handleStep) handleStep(+1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserPreview, (0,_object_spread/* default */.Z)({}, values)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    padding: "$space$3",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        css: {
                            textAlign: "center"
                        },
                        children: "Labels"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 14,
                            textAlign: "center"
                        },
                        children: "Easily identify different digital formats"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Root */.fC, {
                        value: values.labels ? "on" : "off",
                        onValueChange: handleValueChange,
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                width: "100%",
                                flexDirection: "column",
                                "&>*": {
                                    marginBottom: "$space$4",
                                    "&:last-child": {
                                        marginBottom: "unset"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "on",
                                    label: "Enable"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "off",
                                    label: "Disable"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    padding: "$space$3",
                    justifyContent: "space-between"
                },
                vertical: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 12
                        },
                        children: "4 / 5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "simple",
                                onClick: function() {
                                    return handleStep && handleStep(-1);
                                },
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "secondary",
                                onClick: handleClick,
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/layout.tsx









var Layout = function(param) {
    var values = param.values, handleChange = param.handleChange, handleStep = param.handleStep;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleValueChange = function(nextValue) {
        if (handleChange) {
            handleChange("layout", nextValue);
        }
        dispatch({
            type: settings/* actions.SETTINGS_CHANGE_APPEARANCE_LAYOUT */.Nw.SETTINGS_CHANGE_APPEARANCE_LAYOUT,
            payload: nextValue
        });
    };
    var handleClick = function() {
        handleValueChange(values.layout);
        if (handleStep) handleStep(+1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserPreview, (0,_object_spread/* default */.Z)({}, values)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    padding: "$space$3",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        css: {
                            textAlign: "center"
                        },
                        children: "Layout"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 14,
                            textAlign: "center"
                        },
                        children: "Choose a layout that works for you"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Root */.fC, {
                        value: values.layout,
                        onValueChange: handleValueChange,
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                width: "100%",
                                flexDirection: "column",
                                "&>*": {
                                    marginBottom: "$space$4",
                                    "&:last-child": {
                                        marginBottom: "unset"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: constants/* FEED_LAYOUT.MASONRY */.Gf.MASONRY,
                                    label: "Masonry"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: constants/* FEED_LAYOUT.GRID */.Gf.GRID,
                                    label: "Grid"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: constants/* FEED_LAYOUT.VERTICAL */.Gf.VERTICAL,
                                    label: "Vertical"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    padding: "$space$3",
                    justifyContent: "space-between"
                },
                vertical: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 12
                        },
                        children: "1 / 5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            variant: "secondary",
                            onClick: handleClick,
                            children: "Next"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/market.tsx








var Market = function(param) {
    var values = param.values, handleChange = param.handleChange, handleStep = param.handleStep;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleValueChange = function(nextValue) {
        if (handleChange) {
            handleChange("market", nextValue === "on");
        }
        dispatch({
            type: settings/* actions.SETTINGS_CHANGE_APPEARANCE_MARKET */.Nw.SETTINGS_CHANGE_APPEARANCE_MARKET,
            payload: nextValue === "on"
        });
    };
    var handleClick = function() {
        handleValueChange(values.market ? "on" : "off");
        if (handleStep) handleStep(+1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserPreview, (0,_object_spread/* default */.Z)({}, values)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    padding: "$space$3",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        css: {
                            textAlign: "center"
                        },
                        children: "Market"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 14,
                            textAlign: "center"
                        },
                        children: "Display market availability"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Root */.fC, {
                        value: values.market ? "on" : "off",
                        onValueChange: handleValueChange,
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                width: "100%",
                                flexDirection: "column",
                                "&>*": {
                                    marginBottom: "$space$4",
                                    "&:last-child": {
                                        marginBottom: "unset"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "on",
                                    label: "Enable"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "off",
                                    label: "Disable"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    padding: "$space$3",
                    justifyContent: "space-between"
                },
                vertical: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 12
                        },
                        children: "3 / 5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "simple",
                                onClick: function() {
                                    return handleStep && handleStep(-1);
                                },
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "secondary",
                                onClick: handleClick,
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/selector-theme/index.tsx + 1 modules
var selector_theme = __webpack_require__(76469);
// EXTERNAL MODULE: ./src/utils/localstorage.ts
var localstorage = __webpack_require__(77164);
;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/theme.tsx


/* eslint-disable @typescript-eslint/no-explicit-any */ 






var Theme = function(param) {
    var values = param.values, handleStep = param.handleStep;
    var ref = (0,react.useState)(selector_theme/* SelectorThemeTypes.system */.S.system), defaultValue = ref[0], setDefaultValue = ref[1];
    var changeTheme = function(theme) {
        (0,localstorage/* setItem */.LS)("--versum-theme", theme);
        setDefaultValue(theme);
        if (theme !== selector_theme/* SelectorThemeTypes.system */.S.system) {
            document.documentElement.dataset.theme = theme;
        } else {
            delete document.documentElement.dataset.theme;
        }
    };
    (0,react.useEffect)(function() {
        setDefaultValue(document.documentElement.dataset.theme || selector_theme/* SelectorThemeTypes.system */.S.system);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserPreview, (0,_object_spread/* default */.Z)({}, values)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    padding: "$space$3",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        css: {
                            textAlign: "center"
                        },
                        children: "Theme"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 14,
                            textAlign: "center"
                        },
                        children: "Choose your preference"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Root */.fC, {
                        value: defaultValue,
                        onValueChange: changeTheme,
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                width: "100%",
                                flexDirection: "column",
                                "&>*": {
                                    marginBottom: "$space$4",
                                    "&:last-child": {
                                        marginBottom: "unset"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "system",
                                    label: "System"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "dark",
                                    label: "Dark"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioItem, {
                                    value: "light",
                                    label: "Light"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    padding: "$space$3",
                    justifyContent: "space-between"
                },
                vertical: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 12
                        },
                        children: "5 / 5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "simple",
                                onClick: function() {
                                    return handleStep && handleStep(-1);
                                },
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "secondary",
                                onClick: function() {
                                    return handleStep && handleStep(+1);
                                },
                                children: "Finish"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/welcome.tsx

/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-alert */ 

var Path = (0,stitches/* styled */.zo)("path", {
    fill: "$primaryFill"
});
function Welcome(param) {
    var handleStep = param.handleStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    backgroundColor: "$secondaryBackground"
                },
                horizontal: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        marginTop: 32,
                        height: 150,
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        width: "107",
                        height: "101",
                        viewBox: "0 0 107 101",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                                d: "M99.94 21.14C97.9992 17.6977 95.678 14.4843 93.02 11.56L57.74 46.84L93.02 82.14C95.6789 79.1984 98.0001 75.9683 99.94 72.51L74.29 46.8L99.94 21.14Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                                d: "M27.51 0.0400019C24.0437 1.99874 20.8128 4.34732 17.88 7.04L53.22 42.32L88.5 7.04C85.5753 4.35965 82.3623 2.01196 78.92 0.0400019L53.22 25.75L27.51 0.0400019Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                                d: "M89.19 40.97L83.34 46.82L89.19 52.68H106.12C106.333 50.7339 106.439 48.7777 106.44 46.82C106.441 44.8656 106.334 42.9126 106.12 40.97H89.19Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                                d: "M13.41 11.54C4.53287 21.1153 -0.275596 33.7657 5.80214e-07 46.82C-0.121451 53.8262 1.19993 60.7825 3.88196 67.2562C6.56398 73.7298 10.5493 79.5825 15.59 84.45C26.02 94.88 38.53 100.1 53.22 100.04C66.2754 100.3 78.9289 95.5187 88.55 86.69L13.41 11.54Z"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    padding: "$space$3",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        css: {
                            textAlign: "center"
                        },
                        children: "Welcome to Versum"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 14,
                            textAlign: "center"
                        },
                        children: [
                            "Take a few moments to tailor Versum to you. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Visit Settings to change these configurations at any time."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                css: {
                    padding: "$space$3"
                },
                vertical: true,
                horizontal: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    full: true,
                    onClick: function() {
                        return handleStep && handleStep(+1);
                    },
                    children: "Begin"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/modals/user-onboarding/index.tsx




/* eslint-disable react/no-array-index-key */ /* eslint-disable @typescript-eslint/no-explicit-any */ 








var STEPS = [
    Welcome,
    Layout,
    info_Info,
    Market,
    Labels,
    Theme
];
var UserOnboarding = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, _layout = param.layout, layout = _layout === void 0 ? constants/* FEED_LAYOUT.MASONRY */.Gf.MASONRY : _layout, _info = param.info, info = _info === void 0 ? false : _info, _market = param.market, market = _market === void 0 ? false : _market, _labels = param.labels, labels = _labels === void 0 ? false : _labels;
    var ref = (0,react.useState)({
        layout: layout,
        info: info,
        market: market,
        labels: labels
    }), values = ref[0], setValues = ref[1];
    var ref1 = (0,react.useState)(0), step = ref1[0], setStep = ref1[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, value));
        });
    };
    var handleStep = function(increment) {
        var nextStep = step + increment;
        if (nextStep < STEPS.length) {
            setStep(nextStep);
        } else if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        open: open,
        onOpenChange: onOpenChange,
        fill: true,
        opaque: true,
        /* only available if Terms are enabled large={step === 5} */ canClose: false,
        children: STEPS.map(function(Component, index) {
            if (step === index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                    values: values,
                    handleChange: handleChange,
                    handleStep: handleStep
                }, "slide-".concat(index));
            }
            return null;
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/user-report/index.tsx






/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-console */ 


var UserReport = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, viewer = param.viewer, userid = param.userid;
    var ref = (0,react.useState)({
        description: {
            error: false,
            data: ""
        }
    }), values = ref[0], setValues = ref[1];
    var handleChange = function(key, value) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: false,
                data: value
            }));
        });
    };
    var setError = function(key, message) {
        setValues(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, key, {
                error: message,
                data: prevValues[key].data
            }));
        });
    };
    var validate = function() {
        var valid = true;
        if (!values.description.data) {
            setError("description", '"Description" is missing');
            valid = false;
        }
        return valid;
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!validate()) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 3;
                        return fetch("/api/user/".concat(userid, "/report"), {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                viewer: viewer,
                                message: values.description.data
                            })
                        }).then(function(e) {
                            return e.json();
                        });
                    case 3:
                        if (onOpenChange) {
                            onOpenChange(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (onOpenChange) {
            onOpenChange(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "Report User",
        description: "Describe why you think this user should be removed from Versum.",
        open: open,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.V, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Field */.gN, {
                uid: "description",
                tooltip: "Though we keep reports anonymous, the reasons for the report are made public so the community can vote on either enforce a ban or not.",
                error: values.description.error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Textarea */.gx, {
                    placeholder: "Tell us some details",
                    value: values.description.data,
                    onChange: function(value) {
                        return handleChange("description", value);
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modals/whats-new/index.tsx




var WhatsNew = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange;
    var dispatch = (0,es/* useDispatch */.I0)();
    var version = "1.1.4" || 0;
    var handleOpenClose = function(value) {
        if (value === false) {
            dispatch({
                type: settings/* actions.SETTINGS_CHANGE_CHANGELOG_VERSION */.Nw.SETTINGS_CHANGE_CHANGELOG_VERSION,
                payload: version
            });
        }
        if (onOpenChange) {
            onOpenChange(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AlertDialog */.aR, {
        title: "New on Versum",
        open: open,
        onOpenChange: handleOpenClose,
        canClose: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
            css: {
                width: "100%",
                flexDirection: "column"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    height: 300,
                    flexDirection: "column",
                    justifyContent: "space-between",
                    borderRadius: 5,
                    iframe: {
                        height: "100%"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    title: "Changelog",
                    src: "https://versumstudios.github.io/changelog/log-".concat(version, ".html").concat(window.getTheme && "?theme=".concat(window.getTheme())),
                    frameBorder: "0",
                    sandbox: "allow-same-origin allow-scripts allow-popups"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/modal-manager/index.tsx


/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-console */ 






























var MODALS = [
    // USER
    {
        key: "user-followers",
        Component: UserFollowers
    },
    {
        key: "user-following",
        Component: UserFollowing
    },
    {
        key: "user-report",
        Component: UserReport
    },
    {
        key: "user-block",
        Component: UserBlock
    },
    {
        key: "user-onboarding",
        Component: UserOnboarding
    },
    // MARKET
    {
        key: "auction-create",
        Component: AuctionCreate
    },
    {
        key: "auction-cancel",
        Component: AuctionCancel
    },
    {
        key: "auction-accept-current",
        Component: AuctionAcceptCurrentBid
    },
    {
        key: "auction-bid",
        Component: AuctionBid
    },
    {
        key: "auction-finalize",
        Component: AuctionFinalize
    },
    {
        key: "auction-withdraw",
        Component: AuctionWithdraw
    },
    {
        key: "swap-create",
        Component: SwapCreate
    },
    {
        key: "swap-collect",
        Component: SwapCollect
    },
    {
        key: "swap-cancel",
        Component: SwapCancel
    },
    {
        key: "swap-conclude",
        Component: SwapConclude
    },
    {
        key: "swap-slippage",
        Component: SwapSlippage
    },
    {
        key: "offer-create",
        Component: OfferCreate
    },
    {
        key: "offer-cancel",
        Component: OfferCancel
    },
    {
        key: "offer-accept",
        Component: OfferAccept
    },
    {
        key: "token-transfer",
        Component: TokenTransfer
    },
    {
        key: "token-burn",
        Component: TokenBurn
    },
    // GENERIC
    {
        key: "token-save",
        Component: TokenSave
    },
    {
        key: "profile-edit",
        Component: ProfileEdit
    },
    {
        key: "whats-new",
        Component: WhatsNew
    },
    {
        key: "error-warning",
        Component: ErrorWarning
    },
    // BOARDS
    {
        key: "board-cover-edit",
        Component: BoardCoverEdit
    },
    {
        key: "board-create",
        Component: BoardCreate
    },
    {
        key: "board-delete",
        Component: BoardDelete
    },
    {
        key: "board-edit",
        Component: BoardEdit
    }, 
];
function ModalManager() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var modals = (0,es/* useSelector */.v9)(function(state) {
        return state.modals;
    });
    var handleDialog = function(nextDialog) {
        // Radix modal stores the prop before opening to return to after closing
        document.body.style.pointerEvents = "initial";
        dispatch({
            type: state_modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: nextDialog
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: MODALS.map(function(modal) {
            var ref, ref1;
            if (((ref = modals.modal) === null || ref === void 0 ? void 0 : ref.type) !== modal.key) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal.Component, (0,_object_spread/* default */.Z)({
                open: ((ref1 = modals.modal) === null || ref1 === void 0 ? void 0 : ref1.type) === modal.key,
                onOpenChange: function(value) {
                    return handleDialog(value ? modal.key : "none");
                }
            }, modals.modal), modal.key);
        })
    });
}


/***/ }),

/***/ 76469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ SelectorTheme; },
  "S": function() { return /* binding */ SelectorThemeTypes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/use-intl.esm3.js + 18 modules
var use_intl_esm3 = __webpack_require__(72439);
// EXTERNAL MODULE: ./src/utils/localstorage.ts
var localstorage = __webpack_require__(77164);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/selector-theme/styles.ts



var Container = (0,stitches/* styled */.zo)("div", (0,_define_property/* default */.Z)({}, "& ".concat(index_es/* SelectStyles */.WK), {
    fontSize: 16,
    height: 32,
    "@bp1": {
        fontSize: 14
    }
}));

;// CONCATENATED MODULE: ./src/components/selector-theme/index.tsx






var SelectorThemeTypes;
(function(SelectorThemeTypes) {
    SelectorThemeTypes["system"] = "system";
    SelectorThemeTypes["dark"] = "dark";
    SelectorThemeTypes["light"] = "light";
})(SelectorThemeTypes || (SelectorThemeTypes = {}));
function SelectorTheme() {
    var t = (0,use_intl_esm3/* default */.Z)("common");
    var ref = (0,react.useState)(SelectorThemeTypes.system), defaultValue = ref[0], setDefaultValue = ref[1];
    var changeTheme = function(theme) {
        (0,localstorage/* setItem */.LS)("--versum-theme", theme);
        setDefaultValue(theme);
        if (theme !== SelectorThemeTypes.system) {
            document.documentElement.dataset.theme = theme;
        } else {
            delete document.documentElement.dataset.theme;
        }
    };
    (0,react.useEffect)(function() {
        setDefaultValue(document.documentElement.dataset.theme || SelectorThemeTypes.system);
    }, []);
    var list = [
        {
            value: SelectorThemeTypes.system,
            label: t("system"),
            icon: "computer"
        },
        {
            value: SelectorThemeTypes.dark,
            label: t("dark"),
            icon: "dark_mode"
        },
        {
            value: SelectorThemeTypes.light,
            label: t("light"),
            icon: "light_mode"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Selector */.Qf, {
            value: defaultValue,
            list: list,
            onChange: changeTheme
        })
    });
}


/***/ }),

/***/ 13707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ ThumbnailBoard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/ipfs.ts
var ipfs = __webpack_require__(80125);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/thumbnail-board/styles.ts

var Square = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "$secondaryBackground",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    "&:after": {
        content: "",
        display: "block",
        paddingTop: "calc(1 * 100%);"
    }
});
var Draft = (0,stitches/* styled */.zo)("div", {
    position: "absolute",
    top: 8,
    left: 8,
    zIndex: 1
});
var TokenHolder = (0,stitches/* styled */.zo)("div", {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    "& > *": {
        position: "absolute",
        width: "50%",
        height: "50%",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        "&:nth-child(4n + 1)": {
            top: "0%",
            left: "0%"
        },
        "&:nth-child(4n + 2)": {
            top: "0%",
            left: "50%"
        },
        "&:nth-child(4n + 3)": {
            top: "50%",
            left: "0%"
        },
        "&:nth-child(4n + 4)": {
            top: "50%",
            left: "50%"
        }
    }
});

;// CONCATENATED MODULE: ./src/components/thumbnail-board/index.tsx




var ThumbnailBoard = function(param) {
    var cover = param.cover, images = param.images, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Square, {
            css: {
                backgroundImage: cover && "url(".concat((0,ipfs/* getURLFromIPFSURI */.vR)(cover, ipfs/* Node.INFURA */.NB.INFURA), ")")
            },
            children: [
                !cover && images && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenHolder, {
                    children: images.map(function(image) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            css: {
                                backgroundImage: "url(".concat(image, ")"),
                                imageRendering: "pixelated"
                            }
                        }, image);
                    })
                }),
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        i: {
                            fontSize: 64
                        }
                    },
                    children: icon
                })
            ]
        })
    });
};


/***/ }),

/***/ 79618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ collectionsFetcher; },
/* harmony export */   "Jy": function() { return /* binding */ auctionsFetcher; },
/* harmony export */   "On": function() { return /* binding */ boardsFetcher; },
/* harmony export */   "T7": function() { return /* binding */ swapsFetcher; },
/* harmony export */   "WR": function() { return /* binding */ tokensFetcher; }
/* harmony export */ });
/* unused harmony export fetcher */
var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var tokensFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.tokens;
    });
};
var boardsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.token_lists;
    });
};
var collectionsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.collections;
    });
};
var auctionsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e;
    });
};
var swapsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e;
    });
};


/***/ }),

/***/ 77164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; }
/* harmony export */ });
/* unused harmony exports getItem, removeItem */
var getItem = function(prop) {
    return localStorage.getItem(prop);
};
var setItem = function(prop, value) {
    localStorage.setItem(prop, value);
    return getItem(prop);
};
var removeItem = function(prop) {
    localStorage.removeItem(prop);
};


/***/ }),

/***/ 12857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ getScreenName; },
/* harmony export */   "vW": function() { return /* binding */ getUserName; }
/* harmony export */ });
/* unused harmony export sanitiseProfileImage */
/* harmony import */ var _ipfs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80125);
/* harmony import */ var _wallet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49058);
/* eslint-disable no-console */ 

var sanitiseProfileImage = function() {
    var uri = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (uri && uri.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(uri, Node.INFURA);
    }
    // otherwise its already resolved
    return uri;
};
var getUserName = function(id, name) {
    var userName = name === id ? (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id) : "@".concat(name);
    userName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id); // eventually remove
    return userName;
};
var getScreenName = function(verified, screenName, id, name) {
    // validate empty screen name before
    var parsedScreenName = screenName;
    // if screen name is null we fill it with the address
    if (!screenName) {
        parsedScreenName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id);
    }
    return verified ? parsedScreenName : getUserName(id, name);
};


/***/ })

}]);